import React, { useState } from 'react'
// import { Link } from 'react-router-dom'

import AnimatedBg from 'react-animated-bg'
import DatePicker from 'react-date-picker';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Footer from './Footer';
import Section from './Section';




function Home() {
    const imageList = [
        'url("assets/conferencenew1080.png")',
        'url("assets/hotelfacilitynew1080.png")',
        'url("assets/roomnew1080.png")',
        'url("assets/bixxnew1080.png")',
      ];
      const [checkIn, setCheckIn] = useState(new Date());
      const [checkOut, setCheckOut] = useState(new Date());

    
    return (
        <AnimatedBg
        colors={imageList}
        duration={2}
        delay={1}
        timingFunction="ease-out"
        
        >
    
        <div className='home'>
            <div className="overlay_home"></div>
        <div className="main_table">
        <h2>Exclusive Hotel Deals</h2>

                <div className="content_table">
                <form action="">

                    <div className="heading">

                        <div className="destination_form">
                            
                                <div id="destination" className='destination_input'>
                                    <span className="searchlabel">
                                     <LocationOnIcon />
                                    </span>
                                     <input type="text" id="destination_search" placeholder='Where are you going ?' />
                                </div>
                            
                        </div>
                        <div className="boxes_fixedrow">
                            <div id="check_in" className='checks_input'>
                                <div className="label_checkin">
                                    <label htmlFor="">Check In</label>
                                </div>
                                <div className="input_datepick">
                                    <DatePicker
                                        onChange={setCheckIn}
                                        value={checkIn}
                                    />
                                </div>
                                < ArrowDropDownIcon />
                            </div>
                            <div id="check_out"  className='checks_input'>
                                <div className="label_checkout">
                                    <label htmlFor="">Check Out</label>
                                </div>
                                <div className="input_datepick">
                                    <DatePicker 
                                        onChange={setCheckOut}
                                        value={checkOut}
                                    
                                    />
                                </div>
                                < ArrowDropDownIcon />
                            </div>
                            <div id="rooms"  className='checks_input'>
                                <div className="labels_rooms">
                                    <label htmlFor=""># Rooms</label>
                                </div>
                                <div className="room_quatity">
                                    <input 
                                    type="number" 
                                    name="room" id="" 
                                    placeholder="--"
                                    />
                                </div>
                                <div className="room_size">
                                    1- 1000
                                </div>
                            </div>
                           

                        </div>
                        
                        

                    </div>
                    <button type="submit">Find Deals</button>
                    
                    </form>
                </div>

            </div>
            
            
        </div>
        <Section />
        <Footer />

       
        </AnimatedBg>

    )
}

export default Home
